import { useAgentCapabilities } from "@/features/page_agent/shared/context/AgentCapabilityContext";
import { FIELD_ACTION_SENDS, type ComposedFieldAction, type FieldActionContext } from "../../shared/model/fieldActionContext";

const ACTION_ID = "review_whodrug";
const FIELD_ID = "case.product.products.drug_code";

/** Ask the shared dock without dismissing the review workspace. */
export function useWhoDrugAgentAction(productId: string, releaseId: number, enabled: boolean, showAgent: () => void) {
  const { composeFieldAction, workingField } = useAgentCapabilities();
  const disabledReason = composeFieldAction === null ? "Theragenie is unavailable on this screen."
    : workingField !== null ? "Wait for the current Theragenie request to finish."
    : !releaseId ? "Select a dictionary release first." : undefined;
  const canAsk = enabled && disabledReason === undefined;

  const ask = () => {
    if (!canAsk) return;
    showAgent();
    const handoff: { context: FieldActionContext; action: ComposedFieldAction } = {
      context: { actionId: ACTION_ID, fieldId: FIELD_ID, fieldLabel: "WHODrug coding",
        sectionId: "case.product", recordId: productId, contextIds: ["section.values"] },
      action: { label: "Review WHODrug entry", send: FIELD_ACTION_SENDS.immediate,
        prompt: `Help me choose a WHODrug entry for the selected product. Use dictionary release ID ${releaseId}. `
          + "Read this product's saved details and search the dictionary. Explain the best supported entry, its RID, Drug Code and release, "
          + "or explain why no entry fits. Show a verified suggestion in Review proposed changes so I can compare it before applying. Do not suggest individual field edits." },
    };
    composeFieldAction?.(handoff.context, handoff.action);
  };
  return { canAsk, disabledReason, ask };
}
